import { throwInvalidParameter } from './errors'
import { getObjectKeys } from './tools'

export function enumKeyTryFromString<T>(type: T, str: string): T[keyof T] | undefined {
  const casted = str as keyof T
  const result = type[casted]
  return result
}

export function enumKeyFromString<T extends { [s: number]: string }>(type: T, str: string): T[keyof T] {
  const result = enumKeyTryFromString(type, str)
  if (result === undefined)
    throwInvalidParameter(`<ab67b80d> Unregistered enum value: ${str}. Possible values: ${enumGetKeys(type)}`)
  return result
}

export function enumKeyToString(enumObject: { [s: number]: string }, value: number): string {
  return enumObject[value]
}

export function enumGetKeys(enumObject: { [s: number]: string }): string[] {
  return Object.keys(enumObject).filter(k => isNaN(Number(k)))
}

// gets all enum items as typed enum values
export function enumGetItems<T extends { [s: number]: string }>(enumObject: T): T[keyof T][] {
  return enumGetKeys(enumObject).map(s => (enumObject as { [key: string]: string })[s]) as T[keyof T][]
}

export function enumGetValues(enumObject: { [s: string]: string }): string[] {
  return getObjectKeys(enumObject).map(k => enumObject[k])
}

export function enumValueTryFromString<T extends Record<Key, string>, Key extends string | number>(
  type: T,
  str: string,
): T[keyof T] | undefined {
  for (const key of getObjectKeys(type)) {
    const val = type[key]
    if (val === str) return val
  }
  return undefined
}

export function enumGetNums(enumObject: { [s: number]: string }): number[] {
  return Object.values(enumObject)
    .filter(v => !isNaN(Number(v)))
    .map(v => Number(v))
}

export function enumValueFromString<T extends Record<string, string>>(type: T, str: string): T[keyof T] {
  const result = enumValueTryFromString(type, str)
  if (result === undefined) throwInvalidParameter(`<d6cfdd7b> Unregistered enum value: ${str}`)
  return result
}

/**
 * Maps one enum to other if all values in map type are the same
 */
export function enumMapToSame<T extends `${R}`, R extends string>(v: T): R {
  return v as unknown as R
}
